
<template>
    <div class="row text-left form--items">
        <div class="item--form col-12">
            <label for="zipCode">
                <small>Código Postal</small>
            </label>
            <input
                type="tel"
                id="zipCode"
                v-mask="'#####-###'"
                @blur="getCep"
                v-model="userAddressData.zipCode"
                class="form-control"
            />
            <p class="errors" v-if="!!errors.zipCode">{{errors.zipCode}}</p>
        </div>
        <div class="item--form col-12">
            <label for="streetName">
                <small>Endereço</small>
            </label>
            <input
                type="text"
                id="streetName"
                v-model="userAddressData.streetName"
                @blur="checkValidate(userAddressData.streetName,'streetName','Endereço obrigatório')"
                class="form-control"
            />
            <p class="errors" v-if="!!errors.streetName">{{errors.streetName}}</p>
        </div>
        <div class="item--form col-12">
            <label for="addressNumber">
                <small>Número</small>
            </label>
            <input
                type="tel"
                id="addressNumber"
                v-model="userAddressData.addressNumber"
                @blur="checkValidate(userAddressData.addressNumber,'addressNumber','Número do endereço obrigatório')"
                class="form-control"
                v-mask="'########'"
            />
            <p class="errors" v-if="!!errors.addressNumber">{{errors.addressNumber}}</p>
        </div>
        <div class="item--form col-12">
            <label for="district">
                <small>Bairro</small>
            </label>
            <input
                type="text"
                id="district"
                v-model="userAddressData.district"
                @blur="checkValidate(userAddressData.district,'district','Bairro obrigatório')"
                class="form-control"
            />
            <p class="errors" v-if="!!errors.district">{{errors.district}}</p>
        </div>
        <div class="item--form col-12">
            <label for="city">
                <small>Cidade</small>
            </label>
            <input
                type="text"
                id="city"
                v-model="userAddressData.city"
                @blur="checkValidate(userAddressData.city,'city','Cidade obrigatório')"
                class="form-control"
            />
            <p class="errors" v-if="!!errors.city">{{errors.city}}</p>
        </div>
        <div class="item--form col-12">
            <label for="province">
                <small>Estado</small>
            </label>
            <input
                type="text"
                v-mask="'AA'"
                id="province"
                v-model="userAddressData.province"
                @blur="checkValidate(userAddressData.province,'province','Estado obrigatório')"
                class="form-control"
            />
            <p class="errors" v-if="!!errors.province">{{errors.province}}</p>
        </div>
        <div class="item--form col-12">
            <label for="country">
                <small>País</small>
            </label>
            <model-select
                style="
                    border: transparent;
                    border-bottom: 1px solid #dddddd;
                    border-radius: 0;
                "
                :options="normalizeCountries"
                v-model="userAddressData.country"
                @blur="checkValidate(userAddressData.country,'country','País obrigatório')"
            ></model-select>
            <p class="errors" v-if="!!errors.country">{{errors.country}}</p>
        </div>
    </div>
</template>

<script>
import axios from "axios";

import { ModelSelect } from "vue-search-select";

export default {
    name: "AddressData",
    data: () => {
        return {
		    countries: [],
            errors: {},
        }
    },
    components: {
		ModelSelect
    },
    props: {
        userAddressData:{
            required: true
        },
    },
    created(){
        this.getCountries();
    },
    computed:{
        normalizeCountries() {
            let list = this.countries;
            list.sort(function (a, b) {
                if (a.text > b.text) {
                    return 1;
                }
                if (a.text < b.text) {
                    return -1;
                }
                return 0;
            });
            return list;
        },
    },
    methods:{
        checkValidate(data,nameError,text){
            if (!data) 
                this.$set(this.errors, nameError, text);
            else 
                this.$delete(this.errors, nameError);
        },
        checkError(){
            this.checkValidate(this.userAddressData.zipCode,'zipCode','CEP obrigatório')
            this.checkValidate(this.userAddressData.streetName,'streetName','Endereço obrigatório')
            this.checkValidate(this.userAddressData.addressNumber,'addressNumber','Número do endereço obrigatório')
            this.checkValidate(this.userAddressData.district,'district','Bairro obrigatório')
            this.checkValidate(this.userAddressData.city,'city','Cidade obrigatório')
            this.checkValidate(this.userAddressData.province,'province','Estado obrigatório')
            this.checkValidate(this.userAddressData.country,'country','País obrigatório')

            this.$emit('errorNumbers',Object.keys(this.errors).length)
        },
	    getCep() {
            this.checkValidate(this.userAddressData.zipCode,'zipCode','CEP obrigatório')
            axios({
                method: "get",
                url:
                    "https://viacep.com.br/ws/" +
                    this.userAddressData.zipCode +
                    "/json",
            }).then((response) => {
                if (response.statusText == "OK") {
                    this.userAddressData.streetName = response.data.logradouro;
                    this.userAddressData.district = response.data.bairro;
                    this.userAddressData.city = response.data.localidade;
                    this.userAddressData.province = response.data.uf;
                    this.userAddressData.country = "BR";
                    setTimeout(() => {
                        this.checkError()
                    }, 100);
                }
            })
            .catch((response) => {
				console.log("Erro ao buscar");
			});
        },
        getCountries() {
            axios({
                method: "get",
                url: `${process.env.ROOT_API}api/country`,
            }).then((response) => {
                if (response.data.status === "1") {
                    this.populateCountries(response.data.data);
                }
            });
        },	
        populateCountries(countries) {
            countries.forEach((country) => {
                this.countries.push({
                    value: country.iso,
                    text: country.name,
                });
            });
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/components/organisms/CheckoutStepAddressData.vue